export default __webpack_public_path__ + "static/media/I_wdt_c_cap_2.cba585d5.mp3";